.container {
  height: 100%;
  border: 1px solid var(--grey-300);
  border-radius: 4px;
  overflow: hidden;

  :global([role='cell']) {
    pointer-events: none;
    cursor: default;
  }
}
